import { StyleSheet } from 'react-native'
import type { Theme } from '../../src/theme/getTheme'
import type { ThemeMode } from '../../src/theme/ThemeContext'

/**
 * Theme-aware styles: readable and fits both light and dark themes.
 * Light: subtle glass look with primary-colored text.
 * Dark: card-style background with high-contrast primary text/icon.
 * variant 'light': for use on dark backgrounds (e.g. gradient hero) – white text/icon, transparent pill.
 */
export const getInviteFriendsButtonStyles = (
  theme: Theme,
  themeMode?: ThemeMode,
  variant?: 'default' | 'light'
) => {
  const isDark = themeMode === 'dark'
  const isLightVariant = variant === 'light'
  return StyleSheet.create({
    button: {
      backgroundColor: isLightVariant
        ? 'rgba(255, 255, 255, 0.2)'
        : isDark
          ? theme.background.card
          : 'rgba(255, 255, 255, 0.45)',
      paddingVertical: 8,
      paddingHorizontal: 12,
      borderRadius: 20,
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 6,
      borderWidth: 1,
      borderColor: isLightVariant ? 'rgba(255, 255, 255, 0.5)' : isDark ? theme.gray[200] : theme.gray[400],
    },
    buttonPressed: {
      opacity: 0.7,
    },
    buttonHover: {
      opacity: 0.85,
    },
    buttonText: {
      color: isLightVariant ? theme.white : theme.primary,
      fontSize: 14,
      fontWeight: '600',
    },
  })
}

// Backward compatibility (no themeMode → light)
import { getTheme } from '../../src/theme/getTheme'
export const inviteFriendsButtonStyles = getInviteFriendsButtonStyles(getTheme('light'))
